import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import type SuccessToast from '@alltrails/types/SuccessToast';

export default function useReportingToast(): [SuccessToast, Dispatch<SetStateAction<SuccessToast>>] {
  const [reportingSuccessToast, setReportingSuccessToast] = useState<SuccessToast>({ isVisible: false, text: '' });

  useEffect(() => {
    if (reportingSuccessToast.isVisible) {
      setTimeout(() => {
        setReportingSuccessToast({ isVisible: false, text: '' });
      }, 3000);
    }
  }, [reportingSuccessToast.isVisible]);

  return [reportingSuccessToast, setReportingSuccessToast];
}
